import { Box } from "@material-ui/core";
import { buildChatMessageHistoryUrl } from "../../utils/chat/messageRetention";
import STMemberInfoCard from "../../assets/styles/organisms/memberInfoCard.module.scss";

export const MessageHistoryButton = ({
  channelId,
  lastCreatedAt,
  lastMessageId,
}: {
  channelId: number | null;
  lastCreatedAt: number;
  lastMessageId: number | undefined;
}) => {
  if (!channelId) {
    return null;
  }

  const historyUrl = buildChatMessageHistoryUrl(
    channelId,
    lastCreatedAt,
    lastMessageId,
  );

  return (
    <Box
      style={{
        padding: "12px 16px",
        textAlign: "center",
        marginTop: 16,
      }}
    >
      <button
        type="button"
        className={`${STMemberInfoCard.button_inactive_link} ${STMemberInfoCard.button_common}`}
        style={{
          width: 192,
          margin: "0 auto",
          backgroundColor: "transparent",
          cursor: "pointer",
          boxSizing: "border-box",
        }}
        onClick={() => {
          window.open(historyUrl, "_blank", "noopener,noreferrer");
        }}
      >
        過去の履歴はこちら
      </button>
    </Box>
  );
};
